module.exports = __webpack_public_path__ + "img/pizza-hero-mobile.0ba16254.png";